import { customInstance } from 'lib/api-instance'

export type BookSearchPublisherDto = {
  id: number
  name: string
}

export type BookSearchBookDto = {
  author?: string | null
  name?: string | null
  publisher?: BookSearchPublisherDto | null
  slug?: string | null
  layout?: string | null
  manual_info_checked?: boolean | null
  degree?: string | null
  image?: string | null
  image_url_thumb?: string | null
  image_url_thumb_low?: string | null
  image_url_intermediaria?: string | null
  v2ready?: boolean | null
  max_uses?: number | null
  bookwire?: boolean | null
  description?: string | null
  subtitle?: string | null
  freemium?: boolean | null
  price?: number | null
  english_level?: string | null
  lexile_level?: number | null
  has_ebook?: boolean | null
  is_reading_trail?: boolean | null
  has_audio_book?: boolean | null
  themas?: unknown[] | null
  language?: string | null
}

export type BookSearchFilterItemDto = {
  label: string
  parameter_value: string
  count?: number | null
  order?: number
}

export type BookSearchFilterDto = {
  title: string
  parameter_name: string
  list: BookSearchFilterItemDto[]
}

export type BookSearchResponseDto = {
  books: BookSearchBookDto[]
  search_filters: BookSearchFilterDto[]
}

export type BookSearchRequestDto = {
  search_term?: string | null
  page?: number
  per_page?: number
  fixed_categories?: string[] | null
  imprint_or_publisher?: string[] | null
  opts?: string | null
}

type BookSearchResponseSuccess = {
  data: BookSearchResponseDto
  status: number
  headers: Headers
}

export const bookSearchControllerSearch = async (
  body: BookSearchRequestDto,
  options?: RequestInit
): Promise<BookSearchResponseSuccess> => {
  return customInstance<BookSearchResponseSuccess>('/api-arvore/book-search', {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(body)
  })
}
